export default "/images/da3463eb9023fa981e345d40980fdd12.jpg";